import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';

// import axios from '../../config/axios';
import Header from './components/Header/Header';
import SearchBar from '../../components/SearchBar/SearchBar';
import TableList from './components/TableList/TableList';
import axios from 'axios';
import { get_all_operators } from '../../api/API';
const useStyles = makeStyles(theme => ({
    root: {
        padding: 8
    },

    results: {
        marginTop: theme.spacing(3)
    }
}));


export default function ShowroomOperator() {

    const classes = useStyles();

    const [agencies, setAgencies] = useState([]);

    useEffect(() => {
        let mounted = true;

       
        fetchAdmins();

        return () => {
            mounted = false;
        };
    }, []);
    const fetchAdmins = async () => {

        let data = await get_all_operators();
        if (data) {
            setAgencies(data);
        }
    }; 

    const handleFilter = () => { };
    const handleSearch = () => { };

    return (
        <div
            className={classes.root}
            title="Agency Details"
        >
            <Header />
            {/* <SearchBar
                onSearch={handleSearch}
            /> */}
            {agencies && (
                <TableList
                    refresh={fetchAdmins}
                    className={classes.results}
                    agencies={agencies}
                />
            )}
        </div>
    )
}